import { render, staticRenderFns } from "./updatabanner.vue?vue&type=template&id=0c62a8b2&scoped=true&"
import script from "./updatabanner.vue?vue&type=script&lang=js&"
export * from "./updatabanner.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./updatabanner.vue?vue&type=style&index=1&id=0c62a8b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62a8b2",
  null
  
)

export default component.exports